import axios from 'axios';

export const client = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_ENDPOINT,
  withCredentials: true,
});

// While a user still owes a forced password change, the backend gates most
// endpoints with `403 { error: 'password_change_required' }`. AuthLayer already
// routes such a user to the change-password screen, so any background/global
// request that hits the gate returns an expected, irrelevant 403. Swallow it
// (never resolve) instead of letting it bubble up as an unhandled promise
// rejection, which pops the dev error overlay and looks like a crash. Every
// other error propagates normally.
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error?.response?.status === 403 &&
      error?.response?.data?.error === 'password_change_required'
    ) {
      return new Promise(() => {});
    }
    return Promise.reject(error);
  },
);

export * from './tasksForms';
export * from './currentTaskForm';
export * from './currentUser';
export * from './accountSwitches';
export * from './supportAccess';
export * from './multiAccount';
export * from './mobileUsers';
export * from './locations';
export * from './billing';
export * from './webforms';
export * from './taskAssigns';
export * from './lists';
export * from './findings';
export * from './formAnswers';
export * from './signature';
export * from './assets';
export * from './meters';
export * from './sso';
export * from './nestedLocations';
export * from './askDataScope';
export * from './plannings';
export * from './whatsapp';
export * from './sensors';
